/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import {
  saveDescriptionOfMerchandiseField,
  saveDescriptionOfMerchandiseLineItem,
  saveLineItemWiseCalculation,
  saveMerchandiseMultipleFeilds,
  saveTotals,
  savePgaFlag,
  savePgaDetailsFlag,
  saveSubHrdSectionField,
  saveDomHeaderPartyName,
  saveDomHeaderPartyAddress,
  saveDescriptionOfInvoiceItem,
} from '../api/setFormData';
import _ from 'lodash';
import {
  calculateTotals,
  calculateCurrencyConversion,
  calculateVFD,
  lineItemWiseCalculations,
} from './util';
import * as actions from '../actions/actionTypes';
const initialState = {};

// UPDATE functions control input, SAVE functions call API's and change dependent fields
export default function DescriptionOfMerchandiseReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case 'INITIALIZE_VALUES_DESCRIPTION_OF_MERCHANDISE': {
      // Calculate and set totalLineItemWeight across line items ()
      // action.payload.totalLineItemWeight = sumGrossWeight(
      //   action.payload.merchandiseLineItems
      // )
      return Object.assign({}, state, { ...action.payload });
    }
    case 'SET_HS_DATA_DTL': {
      let hsData = action.hsData;
      let tariff = action.tariff;
      let newLineItems = state.merchandiseLineItems.slice();
      let obj = {
        invoiceId: newLineItems[action.lineItemIndex]['invoiceId'],
        merchandiseId: newLineItems[action.lineItemIndex]['merchandiseId'],
        merchandiseDutyId:
          newLineItems[action.lineItemIndex]['merchandiseDutyId'],
      };
      newLineItems[action.lineItemIndex]['hsUOMQtyDisabled'] = false;
      if (hsData === false) {
        newLineItems[action.lineItemIndex]['hsUOM'] = 'HS_UOM_NOT_REQUIRED';
        newLineItems[action.lineItemIndex]['hsUOMQtyDisabled'] = true;
        obj.hsUOM = 'HS_UOM_NOT_REQUIRED';
        newLineItems[action.lineItemIndex]['rateOfDuty'] = '-999';
        // newLineItems[action.lineItemIndex]['hsQty'] = '-999';
        // obj.hsQty = "-999";
        obj.rateOfDuty = '-999';
        saveMerchandiseMultipleFeilds(obj);
        newLineItems[action.lineItemIndex]['hsUOMQtyDisabled'] = true;
        return Object.assign({}, state, { merchandiseLineItems: newLineItems });
      }
      let dutyRate = '-999';
      let prefTariffs = _.get(
        hsData,
        '[0]["htsNodes"][0]["tariff"]["caTariff"]["prefTariffs"]'
      );
      if (tariff && tariff[0] === 'Most_Favoured_Nation_Tariff') {
        dutyRate = _.get(
          hsData,
          '[0]["htsNodes"][0]["tariff"]["caTariff"]["mfnTariff"]'
        );
      } else if (
        tariff &&
        tariff[0] !== 'Most_Favoured_Nation_Tariff' &&
        prefTariffs &&
        prefTariffs.length === 1
      ) {
        dutyRate = prefTariffs[0].value;
      } else {
        dutyRate = '-999';
      }
      let hsUOM = _.get(
        hsData,
        '[0]["htsNodes"][0]["htsNodes"][0]["quantityUnitOptions"][0]'
      );
      if (hsUOM && hsUOM != 'HS_None') {
        newLineItems[action.lineItemIndex]['hsUOM'] = hsUOM;
        obj.hsUOM = hsUOM;
      } else {
        // newLineItems[action.lineItemIndex]["hsQty"] = "-999";
        newLineItems[action.lineItemIndex]['hsUOM'] = 'HS_UOM_NOT_REQUIRED';
        obj.hsUOM = 'HS_UOM_NOT_REQUIRED';
        // obj.hsQty = "-999";
        newLineItems[action.lineItemIndex]['hsUOMQtyDisabled'] = true;
      }
      if (dutyRate) {
        let D_Rate = dutyRate.replace('%', '') || '-999';
        newLineItems[action.lineItemIndex]['rateOfDuty'] = D_Rate;
        obj.rateOfDuty = D_Rate;
      }
      // let hsDescription = _.get(hsData, "[0][htsNodes][0][htsScheduleDescription]");
      // newLineItems[action.lineItemIndex]['description'] = hsDescription;
      //obj.description = hsDescription || "_BLANK_";

      if (hsUOM || dutyRate) {
        saveMerchandiseMultipleFeilds(obj);
      }
      newLineItems[action.lineItemIndex]['hsUOMQtyDisabled'] = false;
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }

    case 'SET_HS_PGA_DTL': {
      let newLineItems = state.merchandiseLineItems.slice();
      // newLineItems[action.lineItemIndex].hsDataDtl = {
      //   pgaRuling: action.payload || []
      // }
      // return Object.assign({}, state, { merchandiseLineItems: newLineItems })
      if (newLineItems && newLineItems[action.lineItemIndex]) {
        newLineItems[action.lineItemIndex].hsDataDtl = {
          pgaRuling: action.payload || [],
        };
        return Object.assign({}, state, { merchandiseLineItems: newLineItems });
      }
    }

    case 'UPDATE_MERCH_FIELD': {
      return Object.assign({}, state, { [action.field]: action.payload });
    }
    case 'UPDATE_MERCH_LINE_ITEM_FIELD': {
      let newLineItems = state.merchandiseLineItems.slice();
      let index = action.index;
      if (!newLineItems[action.index]) {
        index = 0;
      }
      newLineItems[index][action.field] = action.payload;
      let a = Object.assign({}, state, { merchandiseLineItems: newLineItems });
      return a;
    }
    case 'UPDATE_MERCH_LINE_ITEM_OBJECT': {
      let newLineItems = state.merchandiseLineItems.slice();
      newLineItems[action.index][action.object][action.field] = action.payload;
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }
    case 'ADD_MERCHANDISE_LINE_ITEM': {
      var _newLineItems = state.merchandiseLineItems.slice();
      _newLineItems.push(action.newLineItem);
      return Object.assign({}, state, { merchandiseLineItems: _newLineItems });
    }
    case 'UPDATE_MERCH_OBJECT': {
      let newObj = Object.assign({}, state[action.object]);
      newObj[action.field] = action.payload;
      return Object.assign({}, state, { [action.object]: newObj });
    }
    case 'REMOVE_MERCHANDISE_LINE_ITEM': {
      let lineItemsCopy = state.merchandiseLineItems.slice();
      let newLineItems = lineItemsCopy.filter((item) => {
        return item.merchandiseId !== action.merchandiseId;
      });
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }
    case 'REMOVE_INVOICE_ITEM': {
      let lineItemsCopy = state.merchandiseLineItems.slice();
      let newLineItems = lineItemsCopy.filter((item) => {
        return item.invoiceId !== action.invoiceId;
      });
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }
    case 'SAVE_MERCHANDISE_FIELD': {
      saveDescriptionOfMerchandiseField(action.field, state[action.field]);
      return state;
    }
    case 'SAVE_DOM_HEADER_PARTY_NAME_APPLY_ALL':
       {
      var _newLineItems = state.merchandiseLineItems.slice();
      _newLineItems.map((item) => {
        if (
          item.invoiceId === action.invoiceId &&
          item.merchandiseId === action.merchandiseId
        ) {
          saveDomHeaderPartyName(
            action.invoiceId,
            action.merchandiseId,
            action.manufacturerId,
            action.field,
            action.payload
          ).then((response) => {
            _newLineItems[action.index]['manufacturerId'] =
              response.data.eventMessage.msg;
          });
        }
      });
      return Object.assign({}, state, { merchandiseLineItems: _newLineItems });
    }

    case 'SAVE_MERCHANDISE_LINE_ITEM': {
      var _newLineItems = state.merchandiseLineItems.slice();

      if (state.merchandiseLineItems[action.index]) {
        if (action.field == 'manufacturerStatus' && action.value == 'allowed') {
          saveDescriptionOfMerchandiseLineItem(
            state.merchandiseLineItems[action.index].invoiceId,
            state.merchandiseLineItems[action.index].merchandiseId,
            state.merchandiseLineItems[action.index].merchandiseDutyId,
            action.field,
            action.value
              ? typeof action.value === 'string'
                ? action.value.trim()
                : action.value
              : state.merchandiseLineItems[action.index][action.field]
          ).then((res) => {
            if (!action.manufacturerId || action.manufacturerId == 0) {
              saveDomHeaderPartyName(
                action.invoiceId,
                action.merchandiseId,
                action.manufacturerId,
                'manufacturerName',
                '_BLANK_'
              ).then((response) => {
                _newLineItems[action.index]['manufacturerId'] =
                  response.data.eventMessage.msg;
              });
            }
          });

          return Object.assign({}, state, {
            merchandiseLineItems: _newLineItems,
          });
        } else {
          let response = saveDescriptionOfMerchandiseLineItem(
            state.merchandiseLineItems[action.index].invoiceId,
            state.merchandiseLineItems[action.index].merchandiseId,
            state.merchandiseLineItems[action.index].merchandiseDutyId,
            action.field,
            action.value
              ? typeof action.value === 'string'
                ? action.value.trim()
                : action.value
              : state.merchandiseLineItems[action.index][action.field],
            action.formType
          );
          if(response instanceof Promise){
            response.then((res) => {
              if(action.field === "isItemVoided"){
                let _newLineItems = state.merchandiseLineItems.slice();
                let _newLineItem = state.merchandiseLineItems[action.index]
                if(res.data.eventMessage?.code == 200 && res.data.eventMessage?.msg === "duty fields updated"){
                  _newLineItem["isItemVoided"] = "true";
                }
                else{
                  _newLineItem["isItemVoided"] = "false";
                }
                _newLineItems[action.index] = _newLineItem;
                return Object.assign({}, state, {
                  merchandiseLineItems: _newLineItems,
                });
              }
            })
          }
        }
        return state;
      }
    }

    case 'SAVE_PGA_DETAILS_LINE_ITEM': {
      let newLineItems = state.merchandiseLineItems.slice();
      newLineItems.map((newLineItem) => {
        if (newLineItem.merchandiseId === action.merchandiseId) {
          newLineItem.pgaDetailDataNew = action.pgaDetailDataNew;
        }
      });

      savePgaDetailsFlag(
        action.merchandiseId,
        action.field,
        action.pgaDetailDataNew,
        action.cbsaPgaType,
        action.cbsaPgaSubProgramType
      );
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }
    case 'SAVE_MERCH_DUTY_ITEM': {
      // TODO: handle error message validation from save
      return state;
    }
    case 'SET_LINE_ITEM': {
      let newLineItems = state.merchandiseLineItems.slice();
      newLineItems[action.lineItemIndex] = action.lineItem;
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }

    case actions.UPDATE_TOTALS: {
      return Object.assign({}, state, { ...action.fields });
    }

    case 'UPDATE_AND_SAVE_TOTALS': {
      let newLineItems = state.merchandiseLineItems.slice();
      let totalsObj = calculateTotals(newLineItems);
      if (
        (
          (sessionStorage.getItem("entrySummaryState") !== "STATE_ENTRY_ACCOUNTING_READY"
            && sessionStorage.getItem("entrySummaryState") !== "STATE_ENTRY_ACCOUNTING_ACCEPTED")
          || sessionStorage.getItem("entrySummaryStateCr") !== "STATE_CARGO_RELEASE_READY"
        )
      ) {
        saveTotals(totalsObj);
      }
      return Object.assign({}, state, { totals: totalsObj });
    }
    case 'UPDATE_MERCH_LINE_ITEM_PGA_OBJECT': {
      let newLineItems = state.merchandiseLineItems.slice();
      savePgaFlag(action.id, action.field, action.payload);
      newLineItems.map((newLineItem) => {
        if (newLineItem.merchandiseId === action.id) {
          if (!action.field) {
            newLineItem['pgaFlags'] = {};
          }
          newLineItem[action.field] = action.payload;
        }
      });
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }
    // case "UPDATE_MERCH_LINE_ITEM_PGA_OBJECT": {
    //   let newLineItems = state.merchandiseLineItems.slice();
    //   newLineItems.map(newLineItem => {
    //     if (newLineItem.merchandiseId === action.merchandiseId) {
    //       newLineItem.pgaList = action.pgaList
    //     }
    //   })
    //   savePgaDetailsFlag(action.merchandiseId,  action.pgaList)
    //   return Object.assign({}, state, {merchandiseLineItems: newLineItems })
    // }
    case 'UPDATE_LINE_ITEM_WITH_PGA_DETAILS': {
      let newLineItems = state.merchandiseLineItems.slice();
      newLineItems.map((newLineItem) => {
        if (newLineItem.merchandiseId === action.merchandiseId) {
          newLineItem.pgaDetailData = action.pgaDetailData;
        }
      });
      savePgaDetailsFlag(action.merchandiseId, action.pgaDetailData);
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }
    case 'UPDATE_LINE_ITEM_WISE_CALCULATION_BY_INVOICE_ID': {
      let newLineItems = state.merchandiseLineItems.slice();
      newLineItems.map((item, index) => {
        if (item.invoiceId === action.invoiceId) {
          let lineItem = lineItemWiseCalculations(newLineItems[index]);
          if (lineItem) {
            newLineItems[index]['currencyConversionVal'] =
              lineItem.currencyConversionVal;
            newLineItems[index]['valueForDuty'] = lineItem.valueForDuty;
            newLineItems[index]['customsDuties'] = lineItem.customsDuties;
            newLineItems[index]['totalForTax'] = lineItem.totalForTax;
            newLineItems[index]['gst'] = lineItem.gst;
            newLineItems[index]['total'] = lineItem.lineItemTotal;
            newLineItems[index]['lineItemTotal'] = lineItem.lineItemTotal;
            saveLineItemWiseCalculation(newLineItems[index]);
          }
        }
      });
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }
    case 'UPDATE_LINE_ITEM_WISE_CALCULATION': {
      let newLineItems = state.merchandiseLineItems.slice();

      // lineItemWiseCalculations(newLineItems[action.index]).then((lineItem) => {
        let lineItem = lineItemWiseCalculations(newLineItems[action.index])
        if (!lineItem) {
          return Object.assign({}, state, {
            merchandiseLineItems: newLineItems,
          });
        }
        newLineItems[action.index]['currencyConversionVal'] =
          lineItem?.currencyConversionVal;
        newLineItems[action.index]['valueForDuty'] = lineItem?.valueForDuty;
        newLineItems[action.index]['customsDuties'] = lineItem?.customsDuties;
        newLineItems[action.index]['totalForTax'] = lineItem?.totalForTax;
        newLineItems[action.index]['gst'] = lineItem?.gst;
        newLineItems[action.index]['total'] = lineItem?.lineItemTotal || 0;
        newLineItems[action.index]['lineItemTotal'] = lineItem?.lineItemTotal;
        saveLineItemWiseCalculation(newLineItems[action.index]);
        return Object.assign({}, state, { merchandiseLineItems: newLineItems });
      // });
    }
    case 'CALCULATE_AND_UPDATE_CURRENCY_CONVERSION': {
      let newLineItems = state.merchandiseLineItems.slice();
      let currencyConversionVal = calculateCurrencyConversion(
        action.quantity,
        action.unitPrice
      );
      if (currencyConversionVal) {
        newLineItems[action.index]['currencyConversionVal'] =
          currencyConversionVal;
      }
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }

    case 'CALCULATE_AND_UPDATE_VFD': {
      let newLineItems = state.merchandiseLineItems.slice();
      let valueForDuty = calculateVFD(
        action.currencyConversionVal,
        action.exchangeRate
      );
      if (valueForDuty) {
        newLineItems[action.index]['valueForDuty'] = valueForDuty;
      }
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }
    case actions.ADD_ADDITIONAL_PGA: {
      let newLineItems = state.merchandiseLineItems.slice();
      newLineItems[action.lineItemIndex].hsDataDtl.pgaRuling.push('ADD-PGA');
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }
    case actions.ON_CURRENCY_CODE_OR_DIRECT_SHIPMENT_DATE_CHANGED: {
      let newLineItems = state.merchandiseLineItems.slice();
      newLineItems.map((item, index) => {
        if (item.invoiceId === action.invoiceId) {
          item.rateOfExchange = action.response.exchRate || '-999';
          saveDescriptionOfMerchandiseLineItem(
            action.invoiceId,
            state.merchandiseLineItems[index].merchandiseId,
            state.merchandiseLineItems[index].merchandiseDutyId,
            'rateOfExchange',
            item.rateOfExchange
          );
        }
      });
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
      // setTimeout(()=>{
      //   return Object.assign({}, state, { merchandiseLineItems: newLineItems })
      // }, 2000)
    }

    case actions.ON_EXCHANGE_RATE_ON_INVOICE_CHANGED: {
      let newLineItems = state.merchandiseLineItems.slice();
      newLineItems.map((item, index) => {
        if (item.invoiceId === action.invoiceId) {
          item.rateOfExchange = action.rateOfExchange || '-999';
          saveDescriptionOfMerchandiseLineItem(
            action.invoiceId,
            state.merchandiseLineItems[index].merchandiseId,
            state.merchandiseLineItems[index].merchandiseDutyId,
            'rateOfExchange',
            item.rateOfExchange
          );
        }
        // updateMerchLineItemFeild(index, 'rateOfExchange', item.rateOfExchangev)
      });
      setTimeout(() => {
        return Object.assign({}, state, { merchandiseLineItems: newLineItems });
      }, 0);
    }

    case actions.UPDATE_TOTAL_VFD_AT_SUBHRD: {
      let newLineItems = state.merchandiseLineItems.slice();
      let totalVfd = 0;
      newLineItems.map((item) => {
        let vfd =
          item.valueForDuty && item.valueForDuty != -999
            ? item.valueForDuty
            : 0;
        totalVfd = totalVfd + parseFloat(vfd);
      });
      totalVfd = Math.round(totalVfd);
      saveSubHrdSectionField('totalVFD', totalVfd, state.requestId);
      return state;
    }

    case actions.UPDATE_DOM_HEADERPARTY_ITEM: {
      let newLineItems = state.merchandiseLineItems.slice();
      newLineItems.map((item, index) => {
        if (
          item.invoiceId === action.invoiceId &&
          item.merchandiseId === action.merchandiseId
        ) {
          newLineItems[index][action.field] = action.payload;
        }
      });
      return Object.assign({}, state, { merchandiseLineItems: newLineItems });
    }

    case actions.SAVE_DOM_HEADER_PARTY_NAME: {
      saveDomHeaderPartyName(
        action.invoiceId,
        action.merchandiseId,
        action.manufacturerId,
        action.field,
        action.payload
      );
      return state;
    }

    case actions.UPDATE_DOM_ACTOR_ADDRESS: {
      var _newLineItems = state.merchandiseLineItems.slice();
      _newLineItems.map((item) => {
        if (
          item.invoiceId === action.invoiceId &&
          item.merchandiseId === action.merchandiseId
        ) {
          let newAddress = Object.assign({}, item['mfgAddressInfo']);
          newAddress[action.field] = action.payload;
          item.mfgAddressInfo = newAddress;
        }
      });
      return Object.assign({}, state, { merchandiseLineItems: _newLineItems });
    }

    case actions.SAVE_DOM_HEADER_PARTY_ADDRESS: {
      var _newLineItems = state.merchandiseLineItems.slice();
      _newLineItems.map((item) => {
        if (
          item.invoiceId === action.invoiceId &&
          item.merchandiseId === action.merchandiseId
        ) {
          saveDomHeaderPartyAddress(
            action.formType,
            action.invoiceId,
            action.merchandiseId,
            action.manufacturerId,
            item['mfgAddressInfo']
          );
        }
      });

      return state;
    }

    case actions.GET_TOTAL_INVOICE_AMT: {
      let _newLineItems = state.merchandiseLineItems.slice();
      let invoiceAmount = 0;
      _newLineItems.map((item) => {
        let currencyConversionVal = item.currencyConversionVal || 0;
        if (item.invoiceId === action.invoiceId) {
          invoiceAmount = invoiceAmount + Number(currencyConversionVal);
        }
      });
      invoiceAmount = (Math.round(invoiceAmount * 100) / 100).toFixed(2);
      setTimeout(() => {
        saveDescriptionOfInvoiceItem(
          action.invoiceId,
          'invoiceTotal',
          invoiceAmount
        );
      }, 0);

      return Object.assign({}, state, { merchandiseLineItems: _newLineItems });
    }

    default:
      return state;
  }
}
